import React, { useState } from "react";
import { MdDelete } from "react-icons/md";
import FileUploadIcon from "../../assets/images/folder-open.png";
import "../../style/form.css";
import { useToast } from "../../ToastContext";
import * as Role from "../../Entities/Role";
import PDF from "../../assets/images/PDF.svg";

function UploadFile({
    showError,
    setShowUploadError,
    childFriendsFamilyFiles,
    setchildFriendsFamilyFiles,
    roleId,
    disabled = false,
}) {
    const [isDragging, setIsDragging] = useState(false);
    const toast = useToast();
    const ALLOWED_FILE_TYPES = ["application/pdf"];
    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

    const validateFiles = (files) => {
        const validFiles = files.filter(
            (file) =>
                ALLOWED_FILE_TYPES.includes(file.type) &&
                file.size <= MAX_FILE_SIZE
        );

        if (validFiles.length < files.length) {
            toast.error("Only pdf files under 10MB are allowed.", {
                duration: 7000,
            });
        }

        return validFiles.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const validFiles = validateFiles(selectedFiles);
        setchildFriendsFamilyFiles((prev) => [...prev, ...validFiles]);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const droppedFiles = Array.from(event.dataTransfer.files);
        const validFiles = validateFiles(droppedFiles);
        setchildFriendsFamilyFiles((prev) => [...prev, ...validFiles]);
    };

    const handleFileRemove = (indexToRemove) => {
        setchildFriendsFamilyFiles((prev) => {
            const newFiles = prev.filter((_, index) => index !== indexToRemove);
            URL.revokeObjectURL(prev[indexToRemove].preview);
            return newFiles;
        });
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    return (
        <div className="mb-4">
            {(roleId == Role.REVIEWER) && (<>
                <p>Upload File</p>
                <div
                    className={`file-upload-container ${showError && childFriendsFamilyFiles.length === 0 ? "error-border" : ""
                        } ${isDragging ? "dragging" : ""} ${disabled ? "opacity-50 pointer-events-none" : ""}`}
                    onClick={() => {
                        if (disabled) {
                            return;
                        }
                        document.getElementById("childFriendsFamilyFile").click();
                    }}
                    onDragOver={disabled ? undefined : handleDragOver}
                    onDragLeave={disabled ? undefined : handleDragLeave}
                    onDrop={disabled ? undefined : handleDrop}
                >
                    <img
                        src={FileUploadIcon}
                        width="40px"
                        height="40px"
                        alt="Upload Icon"
                    />
                    <div>
                        <span className="upload-heading-text">Drag your file(s) or </span>
                        <span className="browse-file-text-align">Browse File</span>
                    </div>
                    <p className="para-text-upload">Max 10 MB files are allowed</p>
                    <span className="para-text-upload">PDF only</span>
                </div>
                <input
                    type="file"
                    id="childFriendsFamilyFile"
                    multiple
                    onChange={handleFileChange}
                    disabled={disabled}
                    style={{
                        width: "0.1px",
                        height: "0.1px",
                        opacity: 0,
                        overflow: "hidden",
                        position: "absolute",
                        zIndex: -1,
                    }}
                />
                {showError && childFriendsFamilyFiles.length === 0 && (
                    <p className="error-text">All fields are required.</p>
                )}
                <div style={{ maxHeight: "150px", overflowY: "auto", width: '100%', marginTop: '15px' }}>
                    {childFriendsFamilyFiles.map((fileObj, index) => (
                        <div key={index} class=" flex justify-between items-center w-[100%] bg-[#F5F5F5] p-2 border border-[#BABEBE] rounded mb-2">

                            <div style={{ display: "flex", alignItems: "center", width: "100%", backgroundColor: "#F5F5F5" }}>
                                <img
                                    src={PDF}
                                    width="30px"
                                    height="30px"
                                    alt="File Preview"
                                    style={{ marginRight: "10px", objectFit: "cover" }}
                                />
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                    }}
                                >
                                    <p className="file-name">{fileObj.file.name}</p>
                                    <p className="file-size">{fileObj.file.size} bytes</p>
                                </div>
                            </div>
                            <div>
                                <MdDelete
                                    size={"24px"}
                                    color={"#BABEBE"}
                                    style={{ cursor: disabled ? "not-allowed" : "pointer" }}
                                    onClick={() => {
                                        if (disabled) {
                                            return;
                                        }
                                        handleFileRemove(index);
                                    }}
                                />
                            </div>

                        </div>
                    ))}
                </div>
            </>
            )}
        </div>
    );
}

export default UploadFile;